/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RttrBoardBreakdownRoundMap } from './RttrBoardBreakdownRoundMap';
import {
    RttrBoardBreakdownRoundMapFromJSON,
    RttrBoardBreakdownRoundMapFromJSONTyped,
    RttrBoardBreakdownRoundMapToJSON,
    RttrBoardBreakdownRoundMapToJSONTyped,
} from './RttrBoardBreakdownRoundMap';

/**
 * 
 * @export
 * @interface ChallengeMyRankResponse
 */
export interface ChallengeMyRankResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeMyRankResponse
     */
    isParticipating: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeMyRankResponse
     */
    isQualified: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChallengeMyRankResponse
     */
    rank?: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeMyRankResponse
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeMyRankResponse
     */
    segment?: number;
    /**
     * True when the user is a verified Finals qualifier from an earlier round and is therefore removed from THIS us-race round tab's ranked list. When true, `rank` is omitted; the UI shows a "Finals Qualifier" state (points + details still available).
     * @type {boolean}
     * @memberof ChallengeMyRankResponse
     */
    removedFromTab?: boolean;
    /**
     * The round (segment index) this user qualified in. Present when the user is a verified qualifier.
     * @type {number}
     * @memberof ChallengeMyRankResponse
     */
    qualifyingRound?: number;
    /**
     * This user's per-round board totals (RttrScore.byRound) — round index → total (evergreen-through-round-end + that round's specials). Lets the My Points breakdown header show the selected round's total, matching the main leaderboard tab. Absent pre-cutover.
     * @type {{ [key: string]: number; }}
     * @memberof ChallengeMyRankResponse
     */
    byRound?: { [key: string]: number; };
    /**
     * Board-standing per-round, per-source decomposition (round index → source → points). Evergreen sources carry forward, specials reset; Σ over sources per round === byRound[round]. Drives the reconciling per-round My Points breakdown, identical to the brand-portal member view (same shared computation). Absent pre-cutover; {} on a cut-over challenge with no breakdown yet.
     * @type {{ [key: string]: RttrBoardBreakdownRoundMap; }}
     * @memberof ChallengeMyRankResponse
     */
    boardBreakdown?: { [key: string]: RttrBoardBreakdownRoundMap; };
}

/**
 * Check if a given object implements the ChallengeMyRankResponse interface.
 */
export function instanceOfChallengeMyRankResponse(value: object): value is ChallengeMyRankResponse {
    if (!('isParticipating' in value) || value['isParticipating'] === undefined) return false;
    if (!('isQualified' in value) || value['isQualified'] === undefined) return false;
    return true;
}

export function ChallengeMyRankResponseFromJSON(json: any): ChallengeMyRankResponse {
    return ChallengeMyRankResponseFromJSONTyped(json, false);
}

export function ChallengeMyRankResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeMyRankResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isParticipating': json['isParticipating'],
        'isQualified': json['isQualified'],
        'rank': json['rank'] == null ? undefined : json['rank'],
        'value': json['value'] == null ? undefined : json['value'],
        'segment': json['segment'] == null ? undefined : json['segment'],
        'removedFromTab': json['removedFromTab'] == null ? undefined : json['removedFromTab'],
        'qualifyingRound': json['qualifyingRound'] == null ? undefined : json['qualifyingRound'],
        'byRound': json['byRound'] == null ? undefined : json['byRound'],
        'boardBreakdown': json['boardBreakdown'] == null ? undefined : (mapValues(json['boardBreakdown'], RttrBoardBreakdownRoundMapFromJSON)),
    };
}

export function ChallengeMyRankResponseToJSON(json: any): ChallengeMyRankResponse {
    return ChallengeMyRankResponseToJSONTyped(json, false);
}

export function ChallengeMyRankResponseToJSONTyped(value?: ChallengeMyRankResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isParticipating': value['isParticipating'],
        'isQualified': value['isQualified'],
        'rank': value['rank'],
        'value': value['value'],
        'segment': value['segment'],
        'removedFromTab': value['removedFromTab'],
        'qualifyingRound': value['qualifyingRound'],
        'byRound': value['byRound'],
        'boardBreakdown': value['boardBreakdown'] == null ? undefined : (mapValues(value['boardBreakdown'], RttrBoardBreakdownRoundMapToJSON)),
    };
}

